class FitmentString {
  constructor(year, make, model, submodel, drive_type, fuel_type, doors, type) {
    this.year = year;
    this.make = make;
    this.model = model;
    this.submodel = submodel;
    this.drive_type = drive_type;
    this.fuel_type = fuel_type;
    this.doors = doors;
    this.type = type;
  }
}

function stringToObject(fitmentStrings) {
  let newStrArr;
  let stringsToObjects = [];
  newStrArr = fitmentStrings.split(";");
  newStrArr.forEach((str) => {
    let tempArr;
    tempArr = str.split("|");
    let tempFitmentObject = new FitmentString();
    tempFitmentObject.year = tempArr[0];
    tempFitmentObject.make = tempArr[1];
    tempFitmentObject.model = tempArr[2];
    tempFitmentObject.submodel = tempArr[3];
    tempFitmentObject.drive_type = tempArr[4];
    tempFitmentObject.fuel_type = tempArr[5];
    tempFitmentObject.doors = tempArr[6];
    tempFitmentObject.type = tempArr[7];

    stringsToObjects.push(tempFitmentObject);
  });

  return stringsToObjects;
}

function checkFitment(metafieldsArr, vehicle) {
  let isFitment = false;
  if (metafieldsArr.length > 0 && !isEmpty(vehicle)) {
    metafieldsArr.forEach((item) => {
      if (
        item.year === vehicle.year &&
        (!item.make ||
          !vehicle.make ||
          item.make.toLowerCase() === "*" ||
          item.make.toLowerCase() === vehicle.make.toLowerCase()) &&
        (!item.model ||
          !vehicle.model ||
          item.model.toLowerCase() === "*" ||
          item.model.toLowerCase() === vehicle.model.toLowerCase()) &&
        (!item.submodel ||
          !vehicle.submodel ||
          item.submodel.toLowerCase() === "*" ||
          item.submodel.toLowerCase() === vehicle.submodel.toLowerCase()) &&
        (!item.drive_type ||
          !vehicle.drive_type ||
          item.drive_type.toLowerCase() === "*" ||
          item.drive_type.toLowerCase() === vehicle.drive_type.toLowerCase()) &&
        (!item.fuel_type ||
          !vehicle.fuel_type ||
          item.fuel_type.toLowerCase() === "*" ||
          item.fuel_type.toLowerCase() === vehicle.fuel_type.toLowerCase()) &&
        (!item.doors ||
          !vehicle.doors ||
          item.doors.toLowerCase() === "*" ||
          item.doors.toLowerCase() === vehicle.doors.toLowerCase()) &&
        (!item.type ||
          !vehicle.type ||
          item.type.toLowerCase() === "*" ||
          item.type.toLowerCase() === vehicle.type.toLowerCase())
      ) {
        isFitment = true;
      }
    });
  }

  return isFitment;
}

const getCollectionJson = async (url, page) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${url}&page=${page}`,
      type: "GET",
      success: function (data) {
        resolve(data);
      },
      error: function (error) {
        reject(error);
      },
    });
  });
};

const getAllCollectionData = async (url, total_pages) => {
  try {
    let html = "";
    const promises = [];

    for (let i = 1; i <= total_pages; i++) {
      promises.push(getCollectionJson(url, i));
    }

    const dataResponses = await Promise.all(promises);

    dataResponses.forEach((data) => {
      html += data;
    });

    return html;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

const mainCollectionProductGrid = document.getElementById(
  "main-collection-product-grid"
);
mainCollectionProductGrid.innerHTML = "";

const storedFitmentData = localStorage.getItem("fitmentData");
const hasFitment =
  storedFitmentData &&
  Object.keys(JSON.parse(storedFitmentData).currentVehicle || {}).length > 0;

if (search_key) {
  getAllCollectionData(
    `${baseUrl}/search?q=${search_key}&view=alternative`,
    total_pages
  )
    .then((html) => {
      let i = 0;
      const elements = Array.from(
        new DOMParser()
          .parseFromString(html, "text/html")
          .querySelectorAll(".search_product_item")
      );

      elements.forEach(function (element) {
        i++;
        if (hasFitment) {
          const elementFitmentData = stringToObject(
            element.dataset.str.slice(0, -1)
          );
          const localStorageFitment =
            JSON.parse(storedFitmentData).currentVehicle;

          const fits = checkFitment(elementFitmentData, localStorageFitment);
          const fitmentIndicator = createFitmentIndicator(fits);
          element.insertAdjacentHTML("beforeend", fitmentIndicator);
        }
        mainCollectionProductGrid.appendChild(element);
      });

      const paginationWrapper = document.querySelector(".pagination-wrapper");
      if (paginationWrapper) {
        paginationWrapper.classList.add("hidden");
        const pageHeader = document.querySelector(".page-header");
        pageHeader.textContent = i + ' RESULTS FOUND FOR "' + search_key + '"';
      }
    })
    .catch((error) => {
      console.error(error);
    });
} else {
  getAllCollectionData(
    `${baseUrl}/collections/${collectionHandle}?view=alternative`,
    total_pages
  )
    .then((html) => {
      const elements = Array.from(
        new DOMParser()
          .parseFromString(html, "text/html")
          .querySelectorAll(".product-masonry-item")
      );

      elements.forEach(function (element) {
        if (hasFitment) {
          const elementFitmentData = stringToObject(
            element.dataset.str.slice(0, -1)
          );
          const localStorageFitment =
            JSON.parse(storedFitmentData).currentVehicle;

          const fits = checkFitment(elementFitmentData, localStorageFitment);
          const fitmentIndicator = createFitmentIndicator(fits);
          element.insertAdjacentHTML("beforeend", fitmentIndicator);
        }
        mainCollectionProductGrid.appendChild(element);
      });

      const paginationWrapper = document.querySelector(".pagination-wrapper");
      if (paginationWrapper) {
        paginationWrapper.classList.add("hidden");
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

// Helper functions
function createFitmentIndicator(fits) {
  const iconSrc = fits ? fittedIcon : notFittedIcon; // Defined in global scope of main-search.liquid
  const altText = fits ? "Fits" : "Does not fit";
  const fitmentText = fits ? "Fits" : "Does NOT Fit";
  return `<div class="fitment-indicator ${fits ? "fits" : "not-fits"}">
    <img src="${iconSrc}" alt="${altText}" title="${altText}">
    <span>${fitmentText}</span>
  </div>`;
}
